import React from 'react'

export interface Dialog {
  isOpen: boolean
  open: () => void
  close: () => void
}

export function useDialog() {
  const [isOpen, setShowDialog] = React.useState(false)
  const open = () => setShowDialog(true)
  const close = () => setShowDialog(false)

  return { isOpen, open, close }
}
